export default "__VITE_ASSET__309fe4ed__"